import { GridProps } from '@mui/material/Grid/Grid';
import { FC, PropsWithChildren } from 'react';
import { Breakpoint } from '../../../../common/model/Breakpoint';
import { SxProps } from '../../../../common/system/SxProps';
import { Grid } from '../../../layout/grid/Grid';
import { useMediaQ } from '../../../../hooks/useMediaQ';

type Props = GridProps &
  PropsWithChildren & {
    sx?: SxProps;
    hideRow?: boolean;
    displayAtBreakpoint?: Breakpoint;
  };

export const ListHeaderRow: FC<Props> = ({ sx, displayAtBreakpoint = 'lg', hideRow, children, ...props }) => {
  const displayBreakpointUp = useMediaQ(displayAtBreakpoint, 'up');

  return displayBreakpointUp && !hideRow ? (
    <Grid container sx={sx} {...props}>
      {children}
    </Grid>
  ) : null;
};
